import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const leftLinks = [
  { to: "/collections", label: "Collections" },
  { to: "/about", label: "About" },
  { to: "/journal", label: "Journal" },
];

const rightLinks = [{ to: "/contact", label: "Contact" }];

const linkClass = ({ isActive }) =>
  `text-xs uppercase tracking-[0.25em] transition-colors duration-300 ${
    isActive ? "text-[#A58343]" : "text-[#262019]/80 hover:text-[#A58343]"
  }`;

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 z-50 w-full border-b border-[#A58343]/20 bg-[#FAF7F1]/70 backdrop-blur-xl"
    >
      <div className="relative mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-8">
        <nav className="hidden flex-1 items-center gap-10 lg:flex" data-testid="nav-left">
          {leftLinks.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkClass} data-testid={`nav-${l.label.toLowerCase()}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/"
          data-testid="brand-wordmark"
          className="absolute left-1/2 -translate-x-1/2 text-center"
        >
          <span className="block font-serif text-2xl font-light uppercase tracking-[0.35em] text-[#262019]">
            Merakee
          </span>
          <span className="mt-0.5 block text-[9px] uppercase tracking-[0.45em] text-[#A58343]">
            Fine Jewellery
          </span>
        </Link>

        <div className="hidden flex-1 items-center justify-end gap-10 lg:flex" data-testid="nav-right">
          {rightLinks.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkClass} data-testid={`nav-${l.label.toLowerCase()}`}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/consultation" className="btn-gold !px-6 !py-2.5" data-testid="nav-book-consultation">
            Book a Private Consultation
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="text-[#A58343] lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} strokeWidth={1.5} /> : <Menu size={24} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="mobile-menu"
          className="border-t border-[#A58343]/20 bg-[#FAF7F1]/95 px-6 py-8 backdrop-blur-xl lg:hidden"
        >
          <div className="flex flex-col gap-6">
            {[...leftLinks, ...rightLinks].map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={(navState) => `${linkClass(navState)} block py-2.5`}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/consultation"
              onClick={() => setOpen(false)}
              className="btn-gold mt-2 w-fit"
              data-testid="mobile-book-consultation"
            >
              Book a Private Consultation
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
};
